import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

// CSS utility functions (requires JavaScript libraries)
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Camadas flutuantes do Radix (Select, DropdownMenu, Popover, Combobox…) são
// renderizadas em portal, FORA da árvore DOM do modal que as contém. Quando uma
// dessas camadas não é modal, ou quando ela desmonta no meio da interação (um
// item cujo onSelect esconde o próprio menu, por exemplo), o pointerdown/focus
// chega ao Dialog como se fosse "fora" e derruba o modal inteiro junto com o
// dropdown. Dialog/AlertDialog usam este teste para ignorar essas interações.
const FLOATING_LAYER_SELECTOR = [
  '[data-radix-popper-content-wrapper]',
  '[data-slot="select-content"]',
  '[data-slot="dropdown-menu-content"]',
  '[role="listbox"]',
  '[role="menu"]',
].join(',')

export function isEventFromFloatingLayer(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(FLOATING_LAYER_SELECTOR))
}

// File download utility (requires DOM manipulation)
export function downloadFile(data: Blob | string, filename: string, mimeType?: string): void {
  const blob = typeof data === 'string' 
    ? new Blob([data], { type: mimeType || 'text/plain' })
    : data;
    
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
